import { API_URL } from './base';
import api from './api';

export const fetchStates = async country => {
    return api.get(`${API_URL}/country/${country}/states/`).then(resp => {
        return resp.data;
    });
};

